import { Link } from 'react-router-dom';

const CALENDLY_URL = 'https://calendly.com/mandieozee/15min';

const footerLinks = [
  { label: 'Home', href: '/' },
  { label: 'About', href: '/about' },
  { label: 'Work With Me', href: '/work-with-me' },
  { label: 'Shop', href: '/shop' },
  { label: 'Women Who Heal', href: '/women-who-heal' },
  { label: 'Contact', href: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-[#FDFAF8]">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-20">
        <div className="flex flex-col items-center text-center">
          {/* Logo */}
          <Link
            to="/"
            className="font-heading text-2xl md:text-4xl tracking-wide text-[#FDFAF8] mb-4"
          >
            MANDIE OZEE.
          </Link>

          {/* Tagline */}
          <p className="font-quote text-sm md:text-lg italic text-[#C9A84C] mb-8">
            Deeply healed. Fully owned. Unapologetically you.
          </p>

          {/* Gold Divider */}
          <div className="w-24 h-px bg-[#C9A84C] mb-10" />

          {/* Links */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-10">
            {footerLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-sm font-body text-[#E8E8E8] hover:text-[#C9A84C] transition-colors duration-300"
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Social Icons */}
          <div className="flex items-center gap-5 mb-10">
            <a
              href="https://instagram.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center text-[#E8E8E8] hover:text-[#C9A84C] transition-colors"
              aria-label="Instagram"
            >
              <i className="ri-instagram-line text-xl" />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center text-[#E8E8E8] hover:text-[#C9A84C] transition-colors"
              aria-label="LinkedIn"
            >
              <i className="ri-linkedin-fill text-xl" />
            </a>
            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center text-[#E8E8E8] hover:text-[#C9A84C] transition-colors"
              aria-label="YouTube"
            >
              <i className="ri-youtube-line text-xl" />
            </a>
          </div>

          {/* Gold Divider */}
          <div className="w-24 h-px bg-[#C9A84C] mb-8" />

          {/* Legal */}
          <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-x-6 gap-y-2 text-xs font-body text-[#AAAAAA]">
            <Link to="/privacy" className="hover:text-[#E8E8E8] transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-[#E8E8E8] transition-colors">
              Terms & Conditions
            </Link>
            <Link to="/shipping" className="hover:text-[#E8E8E8] transition-colors">
              Shipping
            </Link>
            <span>© 2025 Mandie Ozee. All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}